export default __webpack_public_path__ + "static/Need-e8bc87f4ae96ed3c02375aa0b441a3d0.jpg";